<template>
    <kt-form-group v-if="psp_data_status == 'setPspData'">
        <kt-form-action class="mt-4 kt-block-inline">
            <a
                    class="btn btn-md btn-success btn-wide"
                    id="show-psp-data-modal"
                    style="color: #fff; cursor: pointer;"
                    data-toggle="modal"
                    data-target="#psp-data-modal"
            >
                {{ $t('btn.show_psp_data') }}
            </a>
        </kt-form-action>
        <kt-form-action class="mt-4 float-sm-right ml-2 kt-block-inline">
            <button
                    class="btn btn-success"
                    size="sm"
                    type="button"
                    id="export_btn"
                    @click="exportExcel($event)"
            >
                {{ $t('btn.export_psp_data_to_excel') }}
            </button>
        </kt-form-action>
        <div id="psp-data-modal" class="modal fade" role="dialog">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-body">

                        <!--------------------------------------->
                        <!------------ Merchant Data ------------>
                        <!--------------------------------------->
                        <kt-row>
                            <kt-col lg="12" md="12" sm="12">
                                <div class="container p-3 pt-5 my-4 border in-border-header">
                                    <kt-form-section is_first>
                                        <div class="section-header">
                                            {{ $t('label.personal_data') }}
                                        </div>
                                        <kt-row>
                                            <kt-col lg="4" md="6" xs="12">
                                                <kt-form-group>
                                                    <kt-form-label for="merchant_type">
                                                        {{ $t('label.merchant_type') }}
                                                    </kt-form-label>
                                                    <kt-form-control
                                                            id="merchant_type"
                                                            name="merchant_type"
                                                            disabled
                                                            :value="getMerchantType(psp_data.merchant.merchant_type)"
                                                            class="form-control"
                                                    >
                                                    </kt-form-control>
                                                </kt-form-group>
                                            </kt-col>
                                        </kt-row>
                                        <kt-row v-if="psp_data.merchant.merchant_type == 0">
                                            <kt-col lg="4" md="6" xs="12">
                                                <disabled-input
                                                        :title="$t('label.first_name_fa')"
                                                        :val="psp_data.merchant.first_name_fa"
                                                        :idf="'first_name_fa'"
                                                ></disabled-input>
                                            </kt-col>
                                            <kt-col lg="4" md="6" xs="12">
                                                <disabled-input
                                                        :title="$t('label.last_name_fa')"
                                                        :val="psp_data.merchant.last_name_fa"
                                                        :idf="'last_name_fa'"
                                                ></disabled-input>
                                            </kt-col>
                                            <kt-col lg="4" md="6" xs="12">
                                                <disabled-input
                                                        :title="$t('label.father_name_fa')"
                                                        :val="psp_data.merchant.father_name_fa"
                                                        :idf="'father_name_fa'"
                                                ></disabled-input>
                                            </kt-col>
                                            <kt-col lg="4" md="6" xs="12">
                                                <disabled-input
                                                        :title="$t('label.first_name_en')"
                                                        :val="psp_data.merchant.first_name_en"
                                                        :idf="'first_name_en'"
                                                ></disabled-input>
                                            </kt-col>
                                            <kt-col lg="4" md="6" xs="12">
                                                <disabled-input
                                                        :title="$t('label.last_name_en')"
                                                        :val="psp_data.merchant.last_name_en"
                                                        :idf="'last_name_en'"
                                                ></disabled-input>
                                            </kt-col>
                                            <kt-col lg="4" md="6" xs="12">
                                                <disabled-input
                                                        :title="$t('label.father_name_en')"
                                                        :val="psp_data.merchant.father_name_en"
                                                        :idf="'father_name_en'"
                                                ></disabled-input>
                                            </kt-col>
                                            <kt-col lg="4" md="6" xs="12">
                                                <disabled-input
                                                        :title="$t('label.national_code')"
                                                        :val="psp_data.merchant.national_code"
                                                        :idf="'national_code'"
                                                ></disabled-input>
                                            </kt-col>
                                            <kt-col lg="4" md="6" xs="12">
                                                <kt-form-group>
                                                    <kt-form-label for="birth_date">
                                                        {{ $t('label.birth_date') }}
                                                    </kt-form-label>
                                                    <datePicker
                                                            format="YYYY-MM-DD HH:mm:ss"
                                                            display-format="jDD jMMMM jYYYY"
                                                            input-class="form-control"
                                                            id="birth_date"
                                                            name="birth_date"
                                                            disabled
                                                            v-model="psp_data.merchant.birth_date" type="date" />
                                                </kt-form-group>
                                            </kt-col>
                                            <kt-col lg="4" md="6" xs="12">
                                                <disabled-input
                                                        :title="$t('label.birth_crtfct_number')"
                                                        :val="psp_data.merchant.birth_crtfct_number"
                                                        :idf="'birth_crtfct_number'"
                                                ></disabled-input>
                                            </kt-col>
                                            <kt-col lg="4" md="6" xs="12">
                                                <disabled-input
                                                        :title="$t('label.birth_crtfct_serial')"
                                                        :val="psp_data.merchant.birth_crtfct_serial"
                                                        :idf="'birth_crtfct_serial'"
                                                ></disabled-input>
                                            </kt-col>
                                            <kt-col lg="4" md="6" xs="12">
                                                <disabled-input
                                                        :title="$t('label.birth_crtfct_series_letter')"
                                                        :val="getBSCLetter(psp_data.merchant.birth_crtfct_series_letter)"
                                                        :idf="'birth_crtfct_series_letter'"
                                                ></disabled-input>
                                            </kt-col>
                                            <kt-col lg="4" md="6" xs="12">
                                                <disabled-input
                                                        :title="$t('label.birth_crtfct_series_number')"
                                                        :val="psp_data.merchant.birth_crtfct_series_number"
                                                        :idf="'birth_crtfct_series_number'"
                                                ></disabled-input>
                                            </kt-col>
                                            <kt-col lg="4" md="12" xs="12">
                                                <kt-form-group>
                                                    <kt-form-label for="place_of_birth">
                                                        {{ $t('label.place_of_birth') }}
                                                    </kt-form-label>
                                                    <kt-form-control
                                                            id="place_of_birth"
                                                            name="place_of_birth"
                                                            disabled
                                                            v-model="psp_data.merchant.place_of_birth"
                                                    >
                                                    </kt-form-control>
                                                </kt-form-group>
                                            </kt-col>
                                            <kt-col lg="4" md="12" xs="12">
                                                <kt-form-group>
                                                    <kt-form-label for="place_of_birth_crtfct_issue">
                                                        {{ $t('label.place_of_birth_crtfct_issue') }}
                                                    </kt-form-label>
                                                    <kt-form-control
                                                            id="place_of_birth_crtfct_issue"
                                                            name="place_of_birth_crtfct_issue"
                                                            disabled
                                                            v-model="psp_data.merchant.place_of_birth_crtfct_issue"
                                                    >
                                                    </kt-form-control>
                                                </kt-form-group>
                                            </kt-col>
                                            <kt-col lg="4" md="6" xs="12">
                                                <disabled-input
                                                        :title="$t('label.gender')"
                                                        :val="getGender(psp_data.merchant.gender)"
                                                        :idf="'gender'"
                                                ></disabled-input>
                                            </kt-col>
                                            <kt-col lg="4" md="6" xs="12">
                                                <disabled-input
                                                        :title="$t('label.phone')"
                                                        :val="psp_data.merchant.cellphone_number"
                                                        :idf="'cellphone_number'"
                                                ></disabled-input>
                                            </kt-col>
                                            <kt-col lg="4" md="6" xs="12">
                                                <disabled-input
                                                        :title="$t('label.telephone')"
                                                        :val="psp_data.merchant.telephone_number"
                                                        :idf="'telephone_number'"
                                                ></disabled-input>
                                            </kt-col>
                                            <kt-col lg="4" md="6" xs="12">
                                                <disabled-input
                                                        :title="$t('label.email')"
                                                        :val="psp_data.merchant.email_address"
                                                        :idf="'email_address'"
                                                ></disabled-input>
                                            </kt-col>
                                        </kt-row>
                                        <kt-row v-else-if="psp_data.merchant.merchant_type == 1">
                                            <kt-col lg="4" md="6" xs="12">
                                                <disabled-input
                                                        :title="$t('label.com_name_fa')"
                                                        :val="psp_data.merchant.com_name_fa"
                                                        :idf="'com_name_fa'"
                                                ></disabled-input>
                                            </kt-col>
                                            <kt-col lg="4" md="6" xs="12">
                                                <disabled-input
                                                        :title="$t('label.com_name_en')"
                                                        :val="psp_data.merchant.com_name_en"
                                                        :idf="'com_name_en'"
                                                ></disabled-input>
                                            </kt-col>
                                            <kt-col lg="4" md="6" xs="12">
                                                <disabled-input
                                                        :title="$t('label.commercial_name')"
                                                        :val="psp_data.merchant.commercial_name"
                                                        :idf="'commercial_name'"
                                                ></disabled-input>
                                            </kt-col>
                                            <kt-col lg="4" md="6" xs="12">
                                                <disabled-input
                                                        :title="$t('label.national_legal_code')"
                                                        :val="psp_data.merchant.national_legal_code"
                                                        :idf="'national_legal_code'"
                                                ></disabled-input>
                                            </kt-col>
                                            <kt-col lg="4" md="6" xs="12">
                                                <disabled-input
                                                        :title="$t('label.register_number')"
                                                        :val="psp_data.merchant.register_number"
                                                        :idf="'register_number'"
                                                ></disabled-input>
                                            </kt-col>
                                            <kt-col lg="4" md="6" xs="12">
                                                <kt-form-group>
                                                    <kt-form-label for="register_date">
                                                        {{ $t('label.com_register_date') }}
                                                    </kt-form-label>
                                                    <datePicker
                                                            format="YYYY-MM-DD HH:mm:ss"
                                                            display-format="jDD jMMMM jYYYY"
                                                            input-class="form-control"
                                                            id="register_date"
                                                            name="register_date"
                                                            disabled
                                                            v-model="psp_data.merchant.register_date" type="date" />
                                                </kt-form-group>
                                            </kt-col>
                                            <kt-col lg="4" md="6" xs="12">
                                                <disabled-input
                                                        :title="$t('label.place_of_registration')"
                                                        :val="psp_data.merchant.place_of_registration"
                                                        :idf="'register_number'"
                                                ></disabled-input>
                                            </kt-col>
                                            <kt-col lg="4" md="6" xs="12">
                                                <disabled-input
                                                        :title="$t('label.tax_payer_code')"
                                                        :val="psp_data.merchant.tax_payer_code"
                                                        :idf="'tax_payer_code'"
                                                ></disabled-input>
                                            </kt-col>
                                            <kt-col lg="4" md="6" xs="12">
                                                <disabled-input
                                                        :title="$t('label.economic_code')"
                                                        :val="psp_data.merchant.economic_code"
                                                        :idf="'economic_code'"
                                                ></disabled-input>
                                            </kt-col>
                                        </kt-row>
                                    </kt-form-section>
                                </div>
                            </kt-col>
                            <kt-col lg="12" md="12" sm="12" v-if="psp_data.merchant.merchant_type == 1">
                                <div class="container p-3 pb-0 pt-5 my-4 border in-border-header">
                                    <kt-form-section is_first>
                                        <div class="section-header">
                                            {{ $t('label.first_signatory_data') }}
                                        </div>
                                        <kt-row>
                                            <kt-col lg="4" md="6" xs="12">
                                                <disabled-input
                                                        :title="$t('label.first_name_fa')"
                                                        :val="psp_data.merchant.related_merchant.first_name_fa"
                                                        :idf="'signatory_first_name_fa'"
                                                ></disabled-input>
                                            </kt-col>
                                            <kt-col lg="4" md="6" xs="12">
                                                <disabled-input
                                                        :title="$t('label.last_name_fa')"
                                                        :val="psp_data.merchant.related_merchant.last_name_fa"
                                                        :idf="'signatory_last_name_fa'"
                                                ></disabled-input>
                                            </kt-col>
                                            <kt-col lg="4" md="6" xs="12">
                                                <disabled-input
                                                        :title="$t('label.father_name_fa')"
                                                        :val="psp_data.merchant.related_merchant.father_name_fa"
                                                        :idf="'signatory_father_name_fa'"
                                                ></disabled-input>
                                            </kt-col>
                                            <kt-col lg="4" md="6" xs="12">
                                                <disabled-input
                                                        :title="$t('label.first_name_en')"
                                                        :val="psp_data.merchant.related_merchant.first_name_en"
                                                        :idf="'signatory_first_name_en'"
                                                ></disabled-input>
                                            </kt-col>
                                            <kt-col lg="4" md="6" xs="12">
                                                <disabled-input
                                                        :title="$t('label.last_name_en')"
                                                        :val="psp_data.merchant.related_merchant.last_name_en"
                                                        :idf="'signatory_last_name_en'"
                                                ></disabled-input>
                                            </kt-col>
                                            <kt-col lg="4" md="6" xs="12">
                                                <disabled-input
                                                        :title="$t('label.father_name_en')"
                                                        :val="psp_data.merchant.related_merchant.father_name_en"
                                                        :idf="'signatory_father_name_en'"
                                                ></disabled-input>
                                            </kt-col>
                                            <kt-col lg="3" md="6" xs="12">
                                                <disabled-input
                                                        :title="$t('label.national_code')"
                                                        :val="psp_data.merchant.related_merchant.national_code"
                                                        :idf="'signatory_national_code'"
                                                ></disabled-input>
                                            </kt-col>
                                            <kt-col lg="3" md="6" xs="12">
                                                <kt-form-group>
                                                    <kt-form-label for="signatory_birth_date">
                                                        {{ $t('label.birth_date') }}
                                                    </kt-form-label>
                                                    <datePicker
                                                            format="YYYY-MM-DD HH:mm:ss"
                                                            display-format="jDD jMMMM jYYYY"
                                                            input-class="form-control"
                                                            id="signatory_birth_date"
                                                            disabled
                                                            name="signatory_birth_date"
                                                            v-model="psp_data.merchant.related_merchant.birth_date" type="date" />
                                                </kt-form-group>
                                            </kt-col>
                                            <kt-col lg="3" md="6" xs="12">
                                                <disabled-input
                                                        :title="$t('label.birth_crtfct_number')"
                                                        :val="psp_data.merchant.related_merchant.birth_crtfct_number"
                                                        :idf="'signatory_birth_crtfct_number'"
                                                ></disabled-input>
                                            </kt-col>
                                            <kt-col lg="3" md="6" xs="12">
                                                <disabled-input
                                                        :title="$t('label.phone')"
                                                        :val="psp_data.merchant.related_merchant.cellphone_number"
                                                        :idf="'signatory_cellphone_number'"
                                                ></disabled-input>
                                            </kt-col>
                                            <kt-col lg="3" md="6" xs="12">
                                                <disabled-input
                                                        :title="$t('label.birth_crtfct_serial')"
                                                        :val="psp_data.merchant.related_merchant.birth_crtfct_serial"
                                                        :idf="'signatory_birth_crtfct_serial'"
                                                ></disabled-input>
                                            </kt-col>
                                            <kt-col lg="3" md="6" xs="12">
                                                <disabled-input
                                                        :title="$t('label.birth_crtfct_series_letter')"
                                                        :val="getBSCLetter(psp_data.merchant.related_merchant.birth_crtfct_series_letter)"
                                                        :idf="'signatory_birth_crtfct_series_letter'"
                                                ></disabled-input>
                                            </kt-col>
                                            <kt-col lg="3" md="6" xs="12">
                                                <disabled-input
                                                        :title="$t('label.birth_crtfct_series_number')"
                                                        :val="psp_data.merchant.related_merchant.birth_crtfct_series_number"
                                                        :idf="'signatory_birth_crtfct_series_number'"
                                                ></disabled-input>
                                            </kt-col>
                                            <kt-col lg="3" md="6" xs="12">
                                                <disabled-input
                                                        :title="$t('label.gender')"
                                                        :val="getGender(psp_data.merchant.related_merchant.gender)"
                                                        :idf="'signatory_gender'"
                                                ></disabled-input>
                                            </kt-col>
                                        </kt-row>
                                    </kt-form-section>
                                </div>
                            </kt-col>
                            <kt-col lg="12" md="12" sm="12">
                                <div class="container p-3 pb-0 pt-5 my-4 border in-border-header">
                                    <kt-form-section is_first>
                                        <div class="section-header">
                                            {{ $t('label.authentication_file') }}
                                        </div>
                                        <kt-row v-if="psp_data.merchant.merchant_type == 1">
                                            <kt-col lg="6" md="6" xs="12">
                                                <download-file
                                                        :link="psp_data.merchant.meta.rrk_latest_change"
                                                        :title="$t('label.rrk_latest_change')"
                                                ></download-file>
                                            </kt-col>
                                            <kt-col lg="6" md="6" xs="12">
                                                <download-file
                                                        :link="psp_data.merchant.related_merchant.meta.id_card"
                                                        :title="$t('label.id_card')"
                                                ></download-file>
                                            </kt-col>
                                            <kt-col lg="6" md="6" xs="12">
                                                <download-file
                                                        :link="psp_data.merchant.related_merchant.meta.id_card_back"
                                                        :title="$t('label.id_card_back')"
                                                ></download-file>
                                            </kt-col>
                                            <kt-col lg="6" md="6" xs="12">
                                                <download-file
                                                        :link="psp_data.merchant.related_merchant.meta.sejel"
                                                        :title="$t('label.sejel')"
                                                ></download-file>
                                            </kt-col>
                                        </kt-row>
                                        <kt-row v-else>
                                            <kt-col lg="4" md="6" xs="12">
                                                <download-file
                                                        :link="psp_data.merchant.meta.id_card"
                                                        :title="$t('label.id_card')"
                                                ></download-file>
                                            </kt-col>
                                            <kt-col lg="4" md="6" xs="12">
                                                <download-file
                                                        :link="psp_data.merchant.meta.id_card_back"
                                                        :title="$t('label.id_card_back')"
                                                ></download-file>
                                            </kt-col>
                                            <kt-col lg="4" md="6" xs="12">
                                                <download-file
                                                        :link="psp_data.merchant.meta.sejel"
                                                        :title="$t('label.sejel')"
                                                ></download-file>
                                            </kt-col>
                                        </kt-row>
                                    </kt-form-section>
                                </div>
                            </kt-col>
                            <kt-col lg="12" md="12" sm="12" v-if="psp_data.merchant.merchant_type == 1">
                                <div class="container p-3 pb-0 pt-5 my-4 border in-border-header">
                                    <kt-form-section>
                                        <div class="section-header">
                                            {{ $t('label.technical_agent_data') }}
                                        </div>
                                        <kt-row>
                                            <kt-col lg="4" md="4" xs="12">
                                                <disabled-input
                                                        :title="$t('label.first_name')"
                                                        :val="psp_data.merchant.technical_agent.first_name"
                                                        :idf="'first_name'"
                                                ></disabled-input>
                                            </kt-col>
                                            <kt-col lg="4" md="4" xs="12">
                                                <disabled-input
                                                        :title="$t('label.last_name')"
                                                        :val="psp_data.merchant.technical_agent.last_name"
                                                        :idf="'last_name'"
                                                ></disabled-input>
                                            </kt-col>
                                            <kt-col lg="4" md="4" xs="12">
                                                <disabled-input
                                                        :title="$t('label.telephone')"
                                                        :val="psp_data.merchant.technical_agent.telephone_number"
                                                        :idf="'telephone'"
                                                ></disabled-input>
                                            </kt-col>
                                            <kt-col lg="4" md="4" xs="12">
                                                <disabled-input
                                                        :title="$t('label.phone')"
                                                        :val="psp_data.merchant.technical_agent.cellphone_number"
                                                        :idf="'phone'"
                                                ></disabled-input>
                                            </kt-col>
                                            <kt-col lg="4" md="4" xs="12">
                                                <disabled-input
                                                        :title="$t('label.email')"
                                                        :val="psp_data.merchant.technical_agent.email_address"
                                                        :idf="'email'"
                                                ></disabled-input>
                                            </kt-col>
                                            <kt-col lg="4" md="4" xs="12">
                                                <disabled-input
                                                        :title="$t('label.national_code')"
                                                        :val="psp_data.merchant.technical_agent.national_code"
                                                        :idf="'national_code'"
                                                ></disabled-input>
                                            </kt-col>
                                        </kt-row>
                                    </kt-form-section>
                                </div>
                            </kt-col>
                            <kt-col lg="12" md="12" sm="12">
                                <div class="container p-3 pb-0 pt-5 my-4 border in-border-header">
                                    <kt-form-section is_first>
                                        <div class="section-header">
                                            {{ $t('label.shop_data') }}
                                        </div>
                                        <kt-row>
                                            <kt-col lg="6" md="6" xs="12">
                                                <disabled-input
                                                        :title="$t('label.fa_name')"
                                                        :val="psp_data.farsi_name"
                                                        :idf="'farsi_name'"
                                                ></disabled-input>
                                            </kt-col>
                                            <kt-col lg="6" md="6" xs="12">
                                                <disabled-input
                                                        :title="$t('label.en_name')"
                                                        :val="psp_data.english_name"
                                                        :idf="'english_name'"
                                                ></disabled-input>
                                            </kt-col>
                                            <kt-col lg="8" md="8" xs="12">
                                                <disabled-input
                                                        :title="$t('label.subcategory_code')"
                                                        :val="subcategory.value"
                                                        :idf="'subcategory'"
                                                ></disabled-input>
                                            </kt-col>
                                            <kt-col lg="4" md="4" xs="12">
                                                <disabled-input
                                                        :title="$t('label.subcategory_key')"
                                                        :val="subcategory.key"
                                                        :idf="'subcategory_code'"
                                                ></disabled-input>
                                            </kt-col>
                                            <kt-col lg="3" md="3" xs="12">
                                                <disabled-input
                                                        :title="$t('label.province')"
                                                        :val="province"
                                                        :idf="'province'"
                                                ></disabled-input>
                                            </kt-col>
                                            <kt-col lg="3" md="3" xs="12">
                                                <disabled-input
                                                        :title="$t('label.city')"
                                                        :val="psp_data.city"
                                                        :idf="'city'"
                                                ></disabled-input>
                                            </kt-col>
                                            <kt-col lg="6" md="6" xs="12">
                                                <disabled-input
                                                        :title="$t('label.address')"
                                                        :val="psp_data.address.address"
                                                        idf="address"
                                                ></disabled-input>
                                            </kt-col>
                                            <kt-col lg="3" md="3" xs="12">
                                                <disabled-input
                                                        :title="$t('label.postal_code')"
                                                        :val="postal_code"
                                                        idf="address"
                                                ></disabled-input>
                                            </kt-col>
                                            <kt-col lg="3" md="3" xs="12">
                                                <disabled-input
                                                        :title="$t('label.ownership_type')"
                                                        :val="ownership_type"
                                                        idf="ownership_type"
                                                ></disabled-input>
                                            </kt-col>
                                            <kt-col v-if="psp_data.ownership_type == 1" lg="3" md="3" xs="12">
                                                <disabled-input
                                                        :title="$t('label.rental_contract_number')"
                                                        :val="psp_data.rental_contract_number"
                                                        idf="rental_contract_number"
                                                ></disabled-input>
                                            </kt-col>
                                            <kt-col v-if="psp_data.ownership_type == 1" lg="3" md="3" xs="12">
                                                <kt-form-group>
                                                    <kt-form-label for="rental_expiry_date">
                                                        {{ $t('label.rental_expiry_date') }}
                                                    </kt-form-label>
                                                    <datePicker
                                                            format="YYYY-MM-DD HH:mm:ss"
                                                            display-format="jYYYY/jMM/jDD"
                                                            input-class="form-control"
                                                            id="rental_expiry_date"
                                                            name="rental_expiry_date"
                                                            disabled
                                                            v-model="psp_data.rental_expiry_date" type="date" />
                                                </kt-form-group>
                                            </kt-col>
                                        </kt-row>
                                        <kt-row>
                                            <kt-col lg="3" md="3" xs="12">
                                                <disabled-input
                                                        :title="$t('label.business_type')"
                                                        :val="business_type"
                                                        idf="business_type"
                                                ></disabled-input>
                                            </kt-col>
                                            <kt-col lg="4" md="4" xs="12">
                                                <disabled-input
                                                        :title="$t('label.telephone')"
                                                        :val="psp_data.phone_number"
                                                        idf="phone_number"
                                                ></disabled-input>
                                            </kt-col>
                                            <kt-col lg="5" md="5" xs="12">
                                                <disabled-input
                                                        :title="$t('label.email')"
                                                        :val="psp_data.email"
                                                        idf="email"
                                                ></disabled-input>
                                            </kt-col>
                                            <kt-col lg="4" md="4" xs="12">
                                                <disabled-input
                                                        :title="$t('label.certificate_number')"
                                                        :val="psp_data.certificate_number"
                                                        idf="certificate_number"
                                                ></disabled-input>
                                            </kt-col>
                                            <kt-col lg="4" md="4" xs="12">
                                                <kt-form-group>
                                                    <kt-form-label for="certificate_issue_date">
                                                        {{ $t('label.certificate_issue_date') }}
                                                    </kt-form-label>
                                                    <datePicker
                                                            format="YYYY-MM-DD HH:mm:ss"
                                                            display-format="jYYYY/jMM/jDD"
                                                            input-class="form-control"
                                                            id="certificate_issue_date"
                                                            name="certificate_issue_date"
                                                            disabled
                                                            v-model="psp_data.certificate_issue_date" type="date" />
                                                </kt-form-group>
                                            </kt-col>
                                            <kt-col lg="4" md="4" xs="12">
                                                <kt-form-group>
                                                    <kt-form-label for="certificate_expiry_date">
                                                        {{ $t('label.certificate_expiry_date') }}
                                                    </kt-form-label>
                                                    <datePicker
                                                            format="YYYY-MM-DD HH:mm:ss"
                                                            display-format="jYYYY/jMM/jDD"
                                                            input-class="form-control"
                                                            id="certificate_expiry_date"
                                                            name="certificate_expiry_date"
                                                            disabled
                                                            v-model="psp_data.certificate_expiry_date" type="date" />
                                                </kt-form-group>
                                            </kt-col>
                                            <kt-col lg="4" md="4" xs="12">
                                                <disabled-input
                                                        :title="$t('label.etrust_certificate_type')"
                                                        :val="etrust_certificate_type"
                                                        idf="etrust_certificate_type"
                                                ></disabled-input>
                                            </kt-col>
                                            <kt-col lg="4" md="4" xs="12">
                                                <kt-form-group>
                                                    <kt-form-label for="etrust_certificate_issue_date">
                                                        {{ $t('label.etrust_certificate_issue_date') }}
                                                    </kt-form-label>
                                                    <datePicker
                                                            format="YYYY-MM-DD HH:mm:ss"
                                                            display-format="jYYYY/jMM/jDD"
                                                            input-class="form-control"
                                                            id="etrust_certificate_issue_date"
                                                            name="etrust_certificate_issue_date"
                                                            disabled
                                                            v-model="psp_data.etrust_certificate_issue_date" type="date" />
                                                </kt-form-group>
                                            </kt-col>
                                            <kt-col lg="4" md="4" xs="12">
                                                <kt-form-group>
                                                    <kt-form-label for="etrust_certificate_expiry_date">
                                                        {{ $t('label.etrust_certificate_expiry_date') }}
                                                    </kt-form-label>
                                                    <datePicker
                                                            format="YYYY-MM-DD HH:mm:ss"
                                                            display-format="jYYYY/jMM/jDD"
                                                            input-class="form-control"
                                                            id="etrust_certificate_expiry_date"
                                                            name="etrust_certificate_expiry_date"
                                                            disabled
                                                            v-model="psp_data.etrust_certificate_expiry_date" type="date" />
                                                </kt-form-group>
                                            </kt-col>
                                            <kt-col lg="6" md="6" xs="12">
                                                <disabled-input
                                                        :title="$t('label.sheba_number')"
                                                        :val="sheba"
                                                        idf="sheba"
                                                ></disabled-input>
                                            </kt-col>
                                            <kt-col lg="6" md="6" xs="12">
                                                <disabled-input
                                                        :title="$t('label.bank_account_number')"
                                                        :val="psp_data.meta.bank_account_number"
                                                        idf="bank_account_number"
                                                ></disabled-input>
                                            </kt-col>
                                            <kt-col lg="6" md="6" xs="12">
                                                <disabled-input
                                                        :title="$t('label.website_address')"
                                                        :val="psp_data.website_address"
                                                        idf="website_address"
                                                ></disabled-input>
                                            </kt-col>
                                            <kt-col lg="6" md="6" xs="12">
                                                <disabled-input
                                                        :title="$t('label.callback_address')"
                                                        :val="psp_data.callback_address"
                                                        idf="callback_address"
                                                ></disabled-input>
                                            </kt-col>
                                            <kt-col lg="3" md="3" xs="12">
                                                <disabled-input
                                                        :title="$t('label.access_port')"
                                                        :val="psp_data.access_port"
                                                        idf="access_port"
                                                ></disabled-input>
                                            </kt-col>
                                            <kt-col lg="3" md="3" xs="12">
                                                <disabled-input
                                                        :title="$t('label.callback_port')"
                                                        :val="psp_data.callback_port"
                                                        idf="callback_port"
                                                ></disabled-input>
                                            </kt-col>
                                            <kt-col lg="3" md="3" xs="12">
                                                <disabled-input
                                                        :title="$t('label.server_ip')"
                                                        :val="psp_data.server_ip"
                                                        idf="server_ip"
                                                ></disabled-input>
                                            </kt-col>
                                            <kt-col lg="3" md="3" xs="12">
                                                <disabled-input
                                                        :title="$t('label.programming_language')"
                                                        :val="psp_data.programming_language"
                                                        idf="programming_language"
                                                ></disabled-input>
                                            </kt-col>
                                        </kt-row>
                                    </kt-form-section>
                                </div>
                            </kt-col>
                        </kt-row>
                    </div>
                </div>
            </div>
        </div>
    </kt-form-group>
</template>

<script>
import { mapGetters } from 'vuex'
import { subcategories } from '@/constants/subcategories'
import { provinces, fullCities } from '@/constants/provinceCities'
import { birthCrtfctSeriesLetters } from '@/constants/birthCrtfctSeriesLetter'
import { i18n } from '@/plugins/i18n'
import { downloadFile, disabledInput } from './pspDataComponents'
import $ from 'jquery'
import { KTApp } from '@/plugins/core/app'
import axios from "axios";
import {ApiUrl} from "@/common/api.service";
import toastr from "toastr";

export default {
    components: {
        downloadFile,
        disabledInput,
    },
    computed: {
        sheba() {
            return this.psp_data.sheba_numbers[0].number
        },
        subcategory() {
            let subcategory = subcategories.find(subcategory => subcategory.key === this.psp_data.category_code)
            if(subcategory) {
                return {
                    key: subcategory.key,
                    value: subcategory.value,
                }
            }
            return null
        },
        postal_code() {
            return this.psp_data.address.postal_code.replace('-','')
        },
        province() {
            let province = provinces.find(province => province.id === this.psp_data.province)
            if(province) {
                return province.value
            }
            return null
        },
        ownership_type() {
            if (this.psp_data.ownership_type == 0)
                return i18n.t('label.owner')
            if (this.psp_data.ownership_type == 1)
                return i18n.t('label.tenant')

            return null
        },
        business_type() {
            if (this.psp_data.business_type == 0)
                return i18n.t('label.physical')
            if (this.psp_data.business_type == 1)
                return i18n.t('label.physical_and_virtual')
            if (this.psp_data.business_type == 2)
                return i18n.t('label.virtual')

            return null
        },
        etrust_certificate_type() {
            if (this.psp_data.etrust_certificate_type == 0)
                return i18n.t('etrust_certificate_types.other')
            if (this.psp_data.etrust_certificate_type == 1)
                return i18n.t('etrust_certificate_types.one')
            if (this.psp_data.etrust_certificate_type == 2)
                return i18n.t('etrust_certificate_types.two')

            return null
        },
        ...mapGetters('dedicated', [
            'psp_data', 'psp_data_status'
        ]),
        toastr() {
            toastr.options = {
                closeButton: true,
                positionClass: "toast-bottom-center",
                preventDuplicates: true,
                rtl: false
            }

            return toastr
        }
    },
    props: {
        gate_status: {
            require: true,
            type: String
        },
    },
    data() {
        return {
            provinces: provinces,
            categories: subcategories,
            birthCrtfctSeriesLetters: birthCrtfctSeriesLetters,
            wages: [
                {
                    id: 0,
                    value: this.$t('gateway.wages.from_payer')
                },
                {
                    id: 100,
                    value: this.$t('gateway.wages.from_me')
                },
                {
                    id: 50,
                    value: this.$t('gateway.wages.half')
                }
            ],
            'hashid': this.$route.params.hashid,
        }
    },
    mounted() {
        this.$store.dispatch('dedicated/fetchPspData', this.hashid)
        this.addDownload()
    },
    methods: {
        exportExcel(e) {
            let btn = $('#export_btn')
            KTApp.progress(btn)

            axios({
                url: ApiUrl.path('dedicated/admin/excel-export/' + this.hashid),
                method: 'GET',
                responseType: 'blob',
            }).then((response) => {
                var fileURL = window.URL.createObjectURL(new Blob([response.data]));
                var fileLink = document.createElement('a');

                fileLink.href = fileURL;
                fileLink.setAttribute('download', 'psp-form-'+ this.psp_data.farsi_name +'.xlsx');
                document.body.appendChild(fileLink);

                fileLink.click();
            }).catch(({response}) => {
                this.toastr.error(response.data.message)
            }).finally(response => {
                KTApp.unprogress(btn)
            })
        },
        getMerchantType(code) {
            if (code == 0)
                return i18n.t('label.real')
            if (code == 1)
                return i18n.t('label.legal')
        },
        getBSCLetter(code) {
            let data
            for (data in this.birthCrtfctSeriesLetters) {
                if (this.birthCrtfctSeriesLetters.hasOwnProperty(data)) {
                    if (this.birthCrtfctSeriesLetters[data].key == code)
                        return this.birthCrtfctSeriesLetters[data].value
                }
            }
        },
        getGender(code) {
            if (code == 0)
                return i18n.t('label.male')
            if (code == 1)
                return i18n.t('label.female')
        },
        addDownload() {
            $(".download").attr("download", true);
        }
    },
}
</script>

<style scoped>
    .label-file {
        border: 1px solid #ccc;
        width: fit-content;
        cursor: pointer;
        min-width: 200px;
    }
    input[type="file"]::-webkit-file-upload-button {
        visibility: hidden;
    }
    .in-border-header {
        position: relative;
    }
    .section-header {
        font-size: 1.1rem;
        background-color: #fff;
        position: absolute;
        padding: 1px 4px;
        top: 0;
        right: 11px;
        transform: translate(0, -50%);
    }
    .preview_img {
        max-width: 70px;
        max-height: 70px;
        position: absolute;
        top: 10px;
        left: 80px;
    }
</style>